import { useContext } from 'react';
import { LoadingStateContext } from '../context/LoadingStateContext';
/**
 * Custom hook that provides access to the loading state context.
 * Must be used within a LoadingStateProvider component.
 * @returns The loading state context value
 * @public
 */
export const useLoadingStateContext = () => {
  const context = useContext(LoadingStateContext);
  if (typeof context === 'undefined' || context.isLoading === undefined) {
    throw new Error('useLoadingStateContext must be used within a LoadingStateProvider');
  }
  return context;
};